import PropTypes from "prop-types"
import React, { useContext, useEffect, useState } from "react"
import "../../assets/scss/custom/pages/_signup.scss"
import logo from "../../assets/images/cashinvoice_logo.png"
import {
  Row,
  Col,
  Input,
  Button,
  Form,
  Label,
  FormFeedback,
  Alert,
} from "reactstrap"

//redux
import * as Yup from "yup"
import CryptoJS from "crypto-js"
import { Link, useNavigate } from "react-router-dom"
import withRouter from "components/Common/withRouter"
import { callLoginUser } from "http/auth/login"
import { useFormik } from "formik"
import ToastDialog from "common/ToastDialog"
import { SystemConfigurationContext } from "context/systemConfigContext"
import "./authentication.scss"

const Login = props => {
  const [visible, setVisible] = useState(false)
  const navigate = useNavigate()
  const [activeTab, setActiveTab] = useState("dealer")
  const [error, setError] = useState("")
  const [toastInfo, setToastInfo] = useState({
    show: false,
  })
  const { inputMax } = useContext(SystemConfigurationContext)
  const [isSubmitting, setIsSubmitting] = useState(false)
  //meta title
  document.title = "DMS | Login"

  const validationEmail = useFormik({
    enableReinitialize: true,
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: Yup.object({
      email:
        activeTab == "employee"
          ? Yup.string().required("Employee Id is required")
          : Yup.string()
            .email("Must be a valid Email")
            .max(255)
            .required("Dealer Email is required"),
      password: Yup.string().required("Password is required"),
    }),
    onSubmit: async values => {
      setIsSubmitting(true)
      submitUserLogin(values)
    },
  })

  const submitUserLogin = values => {
    const passphrase = process.env.REACT_APP_KEY
    const encrypted = CryptoJS.AES.encrypt(
      values.password,
      passphrase
    ).toString()
    const postParams = {
      password: encrypted,
    }
    if (activeTab == "employee") {
      (postParams["userType"] = "employee"),
        (postParams["employeeId"] = values.email)
    } else {
      postParams["email"] = values.email
    }
    callLoginUser(postParams)
      .then(result => {
        if (result.status) {
          const { data } = result
          localStorage.setItem("isLoggedIn", true)
          if (data?.firstLogin && data?.passwordResetToken) {
            return navigate(`/reset-password?tk=${data?.passwordResetToken}`)
          } else {
            return navigate(`/verify-login/${data?.uuid}`)
          }
        } else {
          const { message } = result
          if (message?.includes("temporarily locked")) {
            setError(message)
            setTimeout(() => {
              setError("")
            }, 4000)
          } else if (message?.includes("currently inactive")) {
            setError(message)
            setTimeout(() => {
              setError("")
            }, 4000)
          } else {
            setToastInfo({ message: message, showToast: true, role: "error" })
          }
        }
      })
      .catch(e => {
        setIsSubmitting(false)
      })
      .finally(f => {
        setIsSubmitting(false)
      })
  }

  const handleToggle = tab => {
    setActiveTab(tab)
  }

  useEffect(() => {
    validationEmail.resetForm()
  }, [activeTab])

  return (
    <React.Fragment>
      <div className="account-pages bg-auth account-pages-bg">
        <>
          <Row
            className="justify-content-center  w-100 h-100 align-items-center w-100 scrollable-height"
          >
            <Col md={6}
              lg={7} xl={8} className="d-none d-md-block" style={{ flex: 'auto' }}>
              <div className="left-section h-100">
                <div className="d-flex justify-content-center w-100 h-100 align-items-center">
                  <img
                    className="img-fluid verification-img"
                    src={"/login5.svg"}
                    alt="Logo"
                  />
                </div>
              </div>
            </Col>
            <Col
              md={6}
              lg={5}
              xl={4}
              style={{
                overflow: "hidden",
                overflowX: "hidden",
                overflowY: "hidden",
              }}
              className="d-flex justify-content-center"
            >
              <div className="form-layout-section ms-4 ms-md-0 h-100 login-section">
                <div className="d-flex w-75 m-auto justify-content-center d-block">
                  <img
                    src={"/subros_logo.png"}
                    alt=""
                    className="img-fluid ci-logo"
                  />
                </div>
                {error && <Alert color="warning">{error}</Alert>}
                <div
                  style={{ textAlign: "center" }}
                  className="d-flex  flex-column align-items-center"
                >
                  <p
                    style={{
                      color: "#344fa0",
                      textAlign: "center",
                      fontSize: "25px",
                      fontWeight: "500",
                    }}
                  >
                    Login
                  </p>
                </div>
                
                <div
                  className="d-flex"
                  style={{ justifyContent: "center", marginTop: "1rem" }}
                >
                  <div className="toggle-switch-container">
                    <div className="toggle-switch">
                      <label
                        className={`switch-label ${activeTab === "employee" ? "active" : ""
                          }`}
                        onClick={() => handleToggle("employee")}
                        onKeyDown={event => {
                          if (event.key === "Enter") {
                            handleToggle("employee")
                          }
                        }}
                      >
                        Employee
                      </label>
                      <label
                        className={`switch-label ${activeTab === "dealer" ? "active" : ""
                          }`}
                        onClick={() => handleToggle("dealer")}
                        onKeyDown={event => {
                          if (event.key === "Enter") {
                            handleToggle("dealer")
                          }
                        }}
                      >
                        Dealer
                      </label>
                      <div
                        className={`slider ${activeTab === "dealer" ? "slide-right" : ""
                          }`}
                      ></div>
                    </div>
                  </div>
                </div>
                <div className="p-2">
                  <Form
                    className="form-horizontal mt-2"
                    style={{ padding: "0px 20px" }}
                    onSubmit={e => {
                      e.preventDefault()
                      validationEmail.handleSubmit()
                      return false
                    }}
                    noValidate
                  >
                    <div className="form-floating mb-3">
                      <Input
                        maxLength={inputMax}
                        name="email"
                        id="validationCustom04"
                        className="form-control"
                        style={{ borderRadius: "1rem" }}
                        placeholder={
                          activeTab === "dealer"
                            ? "Enter Dealer Email"
                            : "Enter Employee Id"
                        }
                        type="email"
                        onChange={validationEmail.handleChange}
                        onBlur={validationEmail.handleBlur}
                        value={validationEmail.values.email || ""}
                        invalid={
                          !!(
                            validationEmail.touched.email &&
                            validationEmail.errors.email
                          )
                        }
                        disabled={isSubmitting}
                      />
                      <Label htmlFor="validationCustom04">
                        {activeTab === "dealer"
                          ? "Dealer Email"
                          : "Employee Id"}
                      </Label>
                      {validationEmail.touched.email &&
                        validationEmail.errors.email ? (
                        <FormFeedback type="invalid">
                          {validationEmail.errors.email}
                        </FormFeedback>
                      ) : null}
                    </div>

                    <div className="form-floating mb-3">
                      <div className="password-info">
                        <div className="form-floating">
                          <Input
                            maxLength={inputMax}
                            type={visible ? "text" : "password"}
                            name="password"
                            className="form-control"
                            style={{ borderRadius: "1rem" }}
                            placeholder="Enter Password"
                            id="validationPassword"
                            onChange={validationEmail.handleChange}
                            onBlur={validationEmail.handleBlur}
                            value={validationEmail.values.password || ""}
                            invalid={
                              !!(
                                validationEmail.touched.password &&
                                validationEmail.errors.password
                              )
                            }
                            disabled={isSubmitting}
                          />
                          <Label htmlFor="validationPassword">Password</Label>
                          {validationEmail.touched.password &&
                            validationEmail.errors.password ? (
                            <FormFeedback type="invalid">
                              {validationEmail.errors.password}
                            </FormFeedback>
                          ) : null}
                        </div>
                        <div
                          onClick={() => setVisible(!visible)}
                          className="password-i"
                          id="passwordInfo"
                          onKeyDown={event => {
                            if (
                              event.key === "Enter" ||
                              event.key === "Space"
                            ) {
                              setVisible(!visible)
                            }
                          }}
                        >
                          {visible ? (
                            <i className="mdi mdi-eye"></i>
                          ) : (
                            <i className="mdi mdi-eye-off"></i>
                          )}
                        </div>
                      </div>
                    </div>

                    <div className="w-100 mt-3 d-flex justify-content-center">
                      <Button
                        type="submit"
                        style={{ backgroundColor: "#344fa0", border: "none" }}
                      >
                        {isSubmitting && (
                          <span
                            className="spinner-border spinner-border-sm ms-2 me-2"
                            aria-hidden="true"
                          ></span>
                        )}
                        {!isSubmitting && <span>Log In</span>}
                        {isSubmitting && (
                          <span>Authenticating</span>
                        )}
                      </Button>
                    </div>

                    <div className="mt-4 text-center">
                      <Link
                        to="/forgot-password"
                        className="text-muted fw-medium"

                      >
                        <i className="mdi mdi-lock me-1" />
                        <span
                          style={{ color: "#344fa0" }}
                        >Forgot your password? </span>
                      </Link>
                    </div>
                  </Form>
                </div>
                <div className="mt-2 text-center p-2">
                  {/* <p className={`${activeTab === "dealer" ? '' : 'hidden-span'} `} style={{ padding: '0px 20px' }}>
                  Do you have any specific inquiries that we can assist you with?
                    <Link
                      to="/register"
                      style={{ color: "#344fa0" }}
                      className="fw-medium"
                    >
                      {" "}
                      Click Here{" "}
                    </Link>{" "}
                  </p> */}

                  { activeTab === "dealer" && <p className={`${activeTab === "dealer" ? '' : 'hidden-span'} `} style={{ padding: '0px 20px' }}>
                  Do you have any specific inquiries that we can assist you with?
                    <Link
                      to="/register"
                      style={{ color: "#344fa0" }}
                      className="fw-medium"
                    >
                      {" "}
                      Click Here{" "}
                    </Link>{" "}
                  </p> 

                  }
                  <p style={{display:"flex",flexDirection:'row',alignItems:"center",justifyContent:"center"}}>© {new Date().getFullYear()} Powered by {" "}
                    <img
                      src={logo}
                      className="img-fluid mx-1"
                      style={{ width: "13px" }}

                    />
                    <Link
                      to="https://www.cashinvoice.in/"
                      target="_blank"
                      style={{ color: "#344fa0" }}
                      className="fw-medium"
                    >
                      {" "}
                      Cashinvoice
                    </Link>{" "}
                  </p>
                </div>
              </div>
            </Col>
          </Row>
        </>
      </div>
      <ToastDialog
        message={toastInfo.message || ""}
        showToast={toastInfo.show}
        role={toastInfo.role}
        onCloseFn={() => setToastInfo({ show: false })}
      ></ToastDialog>
    </React.Fragment>
  )
}

export default withRouter(Login)

Login.propTypes = {
  history: PropTypes.object,
}
